export default "__VITE_ASSET__DGNh5fGV__"